import { ca } from '@cian/analytics';

interface IOffersLoadProps {
  chatId: string;
  opponentId?: number;
  pageNumber: number;
  dealType: string;
  products: Array<{
    id: number;
    offerType: string;
    position: number;
  }>;
}

export function trackOffersLoad({ chatId, opponentId, pageNumber, products, dealType }: IOffersLoadProps) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Open_popup',
    label: 'MyOffers',
    products,
    page: {
      listingType: 'list',
      pageNumber,
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        source: 'chat',
        dealtype: dealType,
      },
    },
  });
}

export function trackSelectedOffersCancel({ chatId, opponentId, pageNumber, products, dealType }: IOffersLoadProps) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyOffers',
    action: 'Click_sopr',
    label: 'Cancel',
    products,
    page: {
      listingType: 'list',
      pageNumber,
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        source: 'chat',
        dealtype: dealType,
      },
    },
  });
}
